export const API_URL = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL
  : 'http://localhost:3333';

const store = process.env.REACT_APP_EXTERNAL_STORE_URL;
export const EXTERNAL_STORE_URL =
  store || 'https://telacompraonline-homologacao.bubbleapps.io';
